import Flex from "@ui-kit/layout/Flex/Flex.web";
import Modal from "@ui-kit/overlays/Modal/Modal.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import { useMemo } from "react";
import MapTimeslotItem from "../MapTimeslotDrawer/MapTimeslotItem/MapTimeslotItem.web";
import { MapTimeslotModalProps } from "./MapTimeslotModal.props";

/**
 * Modal that displays timeslot information for recurring assigned seating events.
 * For mobile and smaller tablet sizes.
 * Used on public assigned seating map pages.
 */
const MapTimeslotModal = ({
  parentEventData,
  currentEventId,
  isOpen,
  onClose,
}: MapTimeslotModalProps) => {
  const { t } = useTranslation("seating");

  // for recurring assigned seating events,
  // it removes the current event from the sidebar
  // so that only the other timeslots are shown
  const filteredChildEvents = useMemo(() => {
    return (
      parentEventData?.child_events?.filter((ce) => ce.id !== currentEventId) ||
      []
    );
  }, [currentEventId, parentEventData?.child_events]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <Modal.Header>{t("Select Event")}</Modal.Header>
      <Modal.Body>
        <Flex direction="column" gap="md">
          {filteredChildEvents?.length === 0 ? (
            <Text>
              {t("Sorry, no other timeslots are available for this event.")}
            </Text>
          ) : (
            filteredChildEvents?.map((ce) => (
              <MapTimeslotItem
                key={ce.id}
                childEvent={ce}
                containerPadding="0px 0px 20px 0px"
                closeModal={onClose}
              />
            ))
          )}
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

export default MapTimeslotModal;
